var forgotSetPassController = {
    elForm: $('#forgotSetPassForm'),
    forgotModalSetPass: $('#forgotModalSetPass'),
    successModal: $('#successModal'),
    pass: '',
    init: function()
    {
        forgotSetPassController.clearForm();
        forgotSetPassController.pass = forgotSetPassController.elForm.find('.js-input-pass').val();

        forgotSetPassController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });

        forgotSetPassController.elForm.find('.js-input-pass').on('click change keyup blur input', function() {
            forgotSetPassController.pass = $(this).val().trim();
        });

        forgotSetPassController.elForm.find('button').on('click', function() {
            forgotSetPassController.submitForm();

            return false;
        });
    },
    submitForm: function()
    {
        if (!forgotSetPassController.validateForm()) {
            forgotSetPassController.showError();

            return false;
        }

        $.post(
            forgotSetPassController.elForm.attr('action'),
            forgotSetPassController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    forgotSetPassController.forgotModalSetPass.modal('hide');
                    forgotSetPassController.clearForm();
                    forgotSetPassController.successModal.modal('show');
                    setTimeout(function() {
                        forgotSetPassController.successModal.modal('hide');
                        $('#loginModal').modal('show');
                        $('#loginModal').find('.tab-pane').removeClass('active');
                        if(forgotSetPassController.forgotModalSetPass.data('forgot-type') === 'phone') {
                            $('#loginTabs li[id="phoneTab"]').tab('show');
                            $('#loginModal').find("#login-by-phone").addClass('active');
                        } else {
                            $('#loginTabs li[id="mailTab"]').tab('show');
                            $('#loginModal').find("#login-by-mail").addClass('active');
                        }
                    }, 3000);
                } else {
                    if(data.message) {
                        forgotSetPassController.forgotModalSetPass.find('.error-text').text(data.message);
                        forgotSetPassController.showError();
                    }
                }
            }, 'json');
    },
    validateForm: function()
    {
        forgotSetPassController.clearForm();
        var regex = /^\S{6,}$/;
        return (forgotSetPassController.pass.length > 5 && regex.test(forgotSetPassController.pass));
    },
    clearForm: function()
    {
        forgotSetPassController.elForm.find('.form-group').removeClass('has-error');
        forgotSetPassController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        forgotSetPassController.elForm.find('.form-group').addClass('has-error');
        forgotSetPassController.elForm.find('.error-text').show();
    }
};

$(function(){
    forgotSetPassController.init();
});